import React, { useState } from "react";
import "../../assets/css/header.css";


const Header = () => {
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeMenu, setActiveMenu] = useState(null); // For dropdown toggling

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const handleMenuClick = (menuIndex) => {
    setActiveMenu(activeMenu === menuIndex ? null : menuIndex);
  };

  return (
    <header className="custom-header">
      <div className="custom-header-container">
        <div className="custom-logo">
          <a href="/">
          <img src="/images/new-website/bhlogo.webp"/>
          </a>
        </div>
        {/* <button
          className="custom-hamburger"
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          ☰
        </button> */}
        <a href="tel:+916366558374">
            <li className="custom-menu-item">
              
              <button className="custom-menu-link-contact">Call Us</button>
            
            </li>
            </a>
        
      </div>
    </header>
  );
};

export default Header;
